import type { InputPuzzle } from "./puzzle.types";

export const PUNDIT_PUZZLES: InputPuzzle[] = [
  {
    p: "020000079500600140360040200050003400030000020000187000000000300000000096900008000",
    s: "124835679598672143367941258851293467739456821642187935415769382283514796976328514",
    d: -1383,
  },
  {
    p: "100008600007061000008090000000500007060004023053000000470010002500020000000000081",
    s: "125348679947261835638795214814532967769184523253976148476819352581423796392657481",
    d: -1383,
  },
  {
    p: "100000800000209065003001700049000000002100000000905000004500082270004000000008030",
    s: "125476893487239165963851724849762351752183649316945278634517982278394516591628437",
    d: -1383,
  },
  {
    p: "000000009050018000703006405060304000000900200307050000010000600000100000802009003",
    s: "126543789459718362783296415261384597548971236397652841915837624634125978872469153",
    d: -1383,
  },
  {
    p: "000590040900036000048000050000200070002600001001000500007000010600300200090040006",
    s: "126598347975436128348721659569213874782654931431879562857962413614387295293145786",
    d: -1383,
  },
  {
    p: "000000006605070002400000900000714000309000000000096100030600800000003070800002041",
    s: "127439586695871432483265917568714293319528764742396158931647825254183679876952341",
    d: -1383,
  },
  {
    p: "020000060500000409000018030400100000067020091091005070803000000070002000000030000",
    s: "129543768538276419746918235485197326367824591291365874813759642974682153652431987",
    d: -1383,
  },
  {
    p: "100000900004900000005000300700002003580041200000060007026010080300000040010800000",
    s: "132654978674938521895127364769582413583741296241369857926413785358276149417895632",
    d: -1383,
  },
  {
    p: "030800004064071002000000050000010740090007000380400900009500008010020000020000000",
    s: "132895674564371892978246351256918743491637285387452916749563128813724569625189437",
    d: -1383,
  },
  {
    p: "130000000000460000009108070090005100070000000650900004000070500080006000500010308",
    s: "135792486728463915469158273893645127274381659651927834316874592982536741547219368",
    d: -1383,
  },
  {
    p: "030067008900508000040200009000000600000000070502000004016003002000409000004070003",
    s: "135967428927548136648231759381724695469385271572196384716853942253419867894672513",
    d: -1383,
  },
  {
    p: "030000040090810030000000001070020090500084006200350000720000008000002000004000950",
    s: "137265849492817635658493271873621594519784326246359187725936418981542763364178952",
    d: -1383,
  },
  {
    p: "000060004056080000920100000370900000000701000800000300000840900060300040700000230",
    s: "137569824456283197928174653375928416642731589891456372213847965569312748784695231",
    d: -1383,
  },
  {
    p: "009805007000700800004009000801000040000000180090002076200600000000300200013000400",
    s: "139845627526731894784269513861573942372496185495182376258614739947358261613927458",
    d: -1383,
  },
  {
    p: "102056000006030040090000160705000084000400010930700000000000600500300000400000070",
    s: "142956837856137249397284165715623984628495713934718526273849651561372498489561372",
    d: -1383,
  },
  {
    p: "100090000008000004760000000094001027800700000000006000000052160900400000050060802",
    s: "145693278238175694769824513694581327812739456573246981487352169926418735351967842",
    d: -1383,
  },
  {
    p: "000000000030060009007051800000870000080032540300000900400790001021000050005000000",
    s: "146928735538467129297351864654879312789132546312546978463795281921683457875214693",
    d: -1383,
  },
  {
    p: "000000000000028710260700090600000000050000308700904000004003500900810000023007000",
    s: "147569832395428716268731495681352974459176328732984651814293567976815243523647189",
    d: -1383,
  },
  {
    p: "040620000900000000000480170000061008000000325750002006500000809000700600300000000",
    s: "147625983982317564635489172423561798816974325759832416571246839298753641364198257",
    d: -1383,
  },
  {
    p: "100060702060080000700000000030040000910000050070006090050204003000000900402003001",
    s: "148569732563782149729431685835947216916328457274156398651294873387615924492873561",
    d: -1383,
  },
  {
    p: "140005000020090000607200300006080250000700000090010040000600000000007093074000600",
    s: "149375862328196574657248319736489251415762938892513746983654127561827493274931685",
    d: -1383,
  },
  {
    p: "100073080000805040000000079001004000030900010200000000360000700000001600000430098",
    s: "149673582723895146658142379871564923436927815295318467364289751982751634517436298",
    d: -1383,
  },
  {
    p: "002000638400000000007062040300940000000806009005010003006003907000000050070000000",
    s: "152794638463581792987362145318945276724836519695217483846153927231679854579428361",
    d: -1383,
  },
  {
    p: "003000000080700050290000000070304000604092000000010008000003002010000800300580910",
    s: "153968724486721359297435681871354296634892175529617438968173542715249863342586917",
    d: -1383,
  },
  {
    p: "000060000900004005860230040701050080000020300000106007000000000045800710000000004",
    s: "154968273932714865867235149721359486586427391493186527279541638645893712318672954",
    d: -1383,
  },
  {
    p: "050000700060071480080020009000090000007010096800000305940200000000000000000860001",
    s: "154983762269571483783426159315698247427315896896742315941257638678139524532864971",
    d: -1383,
  },
  {
    p: "057000000000005100093010800020500000005000080000030704080000060030859000000120070",
    s: "157284936862395147493617825324578691975461283618932754281743569736859412549126378",
    d: -1383,
  },
  {
    p: "107000000000652000003001050008740900000003000000000040071200003800000700620000108",
    s: "157394286984652371263871459518746932746923815392518647471289563839165724625437198",
    d: -1383,
  },
  {
    p: "100000702009700000002305100820500000037000091000400080000100040705000000003009000",
    s: "158946732369712854472385169824591376537268491691473285986127543715634928243859617",
    d: -1383,
  },
  {
    p: "050030024080000006207008010000103000900200500300000290000307000006000700001400000",
    s: "159736824483521976267948315625193487918274563374685291842367159536819742791452638",
    d: -1383,
  },
  {
    p: "000702030340000006076000001605000000080900007030540000001209000000000200500008300",
    s: "159762834348195726276384591615827943482913657937546182861239475793451268524678319",
    d: -1383,
  },
  {
    p: "009003000000021000682000100004530000000700600070000080500002006010000004003409010",
    s: "159843267437621859682957143264538971895714632371296485548172396916385724723469518",
    d: -1383,
  },
  {
    p: "160070300800000000400018026000500060900000004040000172003702000000040800000000003",
    s: "162475389837296415459318726371524968928167534645839172593782641216943857784651293",
    d: -1383,
  },
  {
    p: "002000005030100960000000800040000080010907230090600100900040000003050000701002000",
    s: "162498375834175962579236841247513689615987234398624157986741523423859716751362498",
    d: -1383,
  },
  {
    p: "100700040002030006000040023530800000098000002000000080700000060010580000900400700",
    s: "163728945452931876879645123537862419698174352241359687784293561316587294925416738",
    d: -1383,
  },
  {
    p: "060370000000060100000000070070000000300815007400000008836000001050006000900020035",
    s: "164379852789562143523481976678243519392815467415697328836754291251936784947128635",
    d: -1383,
  },
  {
    p: "000032500000000000590004320400070601056080000000600000007100000080000010005800042",
    s: "164932578273568194598714326429375681756281439831649257947123865682457913315896742",
    d: -1383,
  },
  {
    p: "000400900000020106320009070051007008000010000846000000270000800080900004000030000",
    s: "167485932594723186328169475951347268732816549846592713273654891685971324419238657",
    d: -1383,
  },
  {
    p: "000002093080001500000004020000607040000040801001000005052000700006050004008000900",
    s: "167582493284931567593764128835617249629345871741829635452193786976258314318476952",
    d: -1383,
  },
  {
    p: "060000020304009000000000051091200005000903070000500800602400000500000700080000036",
    s: "167845923354129687928376451791284365845963172236517894672438519513692748489751236",
    d: -1383,
  },
  {
    p: "169000200003000005200390000005004600000010008700800900000070306002061000000000080",
    s: "169485237473126895258397164985734612324619758716852943541978326832561479697243581",
    d: -1383,
  },
  {
    p: "102000004000000300040708000000007050067050100000430090900085073080009060000000000",
    s: "172593684598164327346728915239817456467952138851436792914685273783249561625371849",
    d: -1383,
  },
  {
    p: "002000005409000007003000001300070800005001030200009060090405008004006000000090100",
    s: "172963485469158327853724691346572819985641732217389564691435278724816953538297146",
    d: -1383,
  },
  {
    p: "100000000008007003000310000020000050600098004800700090200054006030000040040001500",
    s: "173485962598267413462319785329146857617598234854723691281954376935672148746831529",
    d: -1383,
  },
  {
    p: "070004000000800710040100005000400020001096000208001000785000060060000500000000092",
    s: "173524689529863714846179235637485921451296378298731456785942163962318547314657892",
    d: -1383,
  },
  {
    p: "100900060608007200000010540980000000030000792000060000001520000009000000700000850",
    s: "174952368658437219392816547985274631436185792217369485841523976569748123723691854",
    d: -1383,
  },
  {
    p: "000004069080020501400050080013008000704100000650000000000569030000000020000800000",
    s: "175384269389726541462951387913648752724135896658297413247569138891473625536812974",
    d: -1383,
  },
  {
    p: "000006980400020000092000000010900000087000040900000650001040700020300001060700030",
    s: "175436982438129576692857314516974823287563149943218657351642798729385461864791235",
    d: -1383,
  },
  {
    p: "006000200234006800000100060090600053400800007000000020010000000080005072005010000",
    s: "176984235234576891958132764897621453423859617561743928712398546389465172645217389",
    d: -1383,
  },
  {
    p: "000230000000001007405700006380000004920060700040000000700000080009005600000083500",
    s: "178236945692541837435798216387952164921364758546817392753629481819475623264183579",
    d: -1383,
  },
  {
    p: "000006402400120000030008000080000000000005810600307090004000001050009000000070658",
    s: "178956432496123785235748169589614327347295816612387594864532971751869243923471658",
    d: -1383,
  },
  {
    p: "009032005080005600000000003800350290060000010000700300090070000001000000007040906",
    s: "179632845382415679546897123814356297763924518925781364698273451431569782257148936",
    d: -1383,
  },
  {
    p: "180300000000000401002049000590060000060400032008050000000000294020000780000600000",
    s: "184376925937825461652149378593261847761498532248753619816537294325914786479682153",
    d: -1383,
  },
  {
    p: "000300609009010000043008000500080200200000057000000086006000900090057000800043000",
    s: "185372649729416835643598721561784293238169457974235186356821974492657318817943562",
    d: -1383,
  },
  {
    p: "080002000003000604040000017200017960500200000600080300010703000000000000000100409",
    s: "186472593753891624942365817234517968598236741671984352419753286827649135365128479",
    d: -1383,
  },
  {
    p: "100970000009005000000002000700050800040100023061000000000201080690000430000040009",
    s: "186974352279635148354812967723459816945168723861723594437291685692587431518346279",
    d: -1383,
  },
  {
    p: "180000400000730500000090600000376090070000000500009006050002840020600000000400003",
    s: "187265439962734518435198672248376195679521384513849726356912847724683951891457263",
    d: -1383,
  },
  {
    p: "187060000000080000200300000050003090000520700008090010006007300090000000030014070",
    s: "187265934543789126269341857652173498914528763378496512426957381791832645835614279",
    d: -1383,
  },
  {
    p: "000600043500030067070200900000050000710000000000700630400009000000840050025000010",
    s: "189675243542938167376214985268153794713496528954782631431529876697841352825367419",
    d: -1383,
  },
  {
    p: "000070060000630180200094000000000004004000391008010000060900040500001000900305000",
    s: "193578462475632189286194735619753824754286391328419657861927543532841976947365218",
    d: -1383,
  },
  {
    p: "000705000000000600805029017340502000010003000500000060000371400002000090000000800",
    s: "193765284274138659865429317346512978917683542528947163689371425432856791751294836",
    d: -1383,
  },
  {
    p: "000000340007900210000000800300800020000031070060540000240000700000000054610008000",
    s: "196285347487963215532714869351897426924631578768542193249356781873129654615478932",
    d: -1383,
  },
  {
    p: "000400000020510000538700060000000000300600007009058200080090701010004000000000940",
    s: "196483572427516389538729164862937415351642897749158236684395721913274658275861943",
    d: -1383,
  },
  {
    p: "108000000000803009027000100000684050700200000006000000450030020000100900030500008",
    s: "198762543564813279327459186913684752785291364246375891451938627872146935639527418",
    d: -1383,
  },
  {
    p: "000800009000700104570006300090000501001060000008009003000002000039000040700050008",
    s: "213845679986723154574916382497238561321564897658179423845392716139687245762451938",
    d: -1383,
  },
  {
    p: "203000000000000590000064210009000700070510800050309004700821050000000900000000000",
    s: "213985647647132598985764213139248765472516839856379124794821356361457982528693471",
    d: -1383,
  },
  {
    p: "004000008600001007005020100109070064400800000800000900006000031000000200500900040",
    s: "214739658693581427785426193159372864467895312832164975976248531341657289528913746",
    d: -1383,
  },
  {
    p: "005090047000300000030704050701000005600040000900085060560030090000200000000000008",
    s: "215896347476352819839714652741623985658947123923185764567438291184279536392561478",
    d: -1383,
  },
  {
    p: "000060740040070500007001000600013025050000010080000000000000906103296000000005000",
    s: "215968743946372581837451269694713825752689314381524697528147936173296458469835172",
    d: -1383,
  },
  {
    p: "010003800000064010705800003902001000400600070007020035080000600000090007000000000",
    s: "216973854398564712745812963952731486431685279867429135589347621623198547174256398",
    d: -1383,
  },
  {
    p: "000054800600100024007008006100030000000005080004006001000000069070020030030000500",
    s: "219654873685173924347298156168932745793415682524786391851347269976521438432869517",
    d: -1383,
  },
  {
    p: "201080000050030200067200014000017000100600480009000000600090040000005000008000001",
    s: "231486957954731268867259314486917532175623489329548176613892745742165893598374621",
    d: -1383,
  },
  {
    p: "004009700000023050890400001000060149020008000000000000000017038006300000008000200",
    s: "234159786167823954895476321783265149621948573459731862942517638516382497378694215",
    d: -1383,
  },
  {
    p: "030590010108060200000002307000000000046000070000000109400108002900004000063000000",
    s: "234597816178463295695812347719385624346921578582746139457138962921654783863279451",
    d: -1383,
  },
  {
    p: "030000700000700602005090000301000007076080000002006001420000900000300000090060480",
    s: "234618759189735642765492138351924867976183524842576391423857916618349275597261483",
    d: -1383,
  },
  {
    p: "030000007000020590006013400040700000000200000510090000300000005607000009004085070",
    s: "235849617481627593976513428843761952769254831512398764398176245657432189124985376",
    d: -1383,
  },
  {
    p: "007000000000000720460000900006130000000900030082000500801060004000400002700085006",
    s: "237891465918546723465327981596138247174952638382674519821769354659413872743285196",
    d: -1383,
  },
  {
    p: "209000080000008006000090000050700304080010002010603700090260050300000000001007000",
    s: "239476185574128936168395247956782314783914562412653798897261453325849671641537829",
    d: -1383,
  },
  {
    p: "030500000510700000040000009000070000000004901000900020902018650800209030050000000",
    s: "239541768518796243647823519496172385325684971781935426972318654864259137153467892",
    d: -1383,
  },
  {
    p: "000004065080200900700000800900320080005006013000000000403000000000000270070005041",
    s: "239874165584261937716539824941327586825496713367158492493712658158643279672985341",
    d: -1383,
  },
  {
    p: "001300509800700000056000004070000000000000020000000986060031000034002090000800140",
    s: "241368579893754261756129834672983415489615327315247986968431752134572698527896143",
    d: -1383,
  },
  {
    p: "000530000500100000000900014012060800400801000000300006000600700050000000370050290",
    s: "241537689598146372637982514912765843463821957785394126824619735159273468376458291",
    d: -1383,
  },
  {
    p: "000008900700400001051002040005000200000001003027360008010090030000000400002080000",
    s: "243718956789456321651932847135879264968241573427365198814597632576123489392684715",
    d: -1383,
  },
  {
    p: "040760090000250010090000000130000000079008200002000067007100000300040500000500100",
    s: "243761895768259413591384726135627984679438251482915367857193642316842579924576138",
    d: -1383,
  },
  {
    p: "000009000050180020710000600000070203090004000002006004009300080800020000024010000",
    s: "243769851956183427718452639465871293197234568382596714679345182831627945524918376",
    d: -1383,
  },
  {
    p: "005780100000002400031040009002004006000000080017600205700000092300000000090000000",
    s: "245789163679312458831546729582974316463251987917638245754163892328495671196827534",
    d: -1383,
  },
  {
    p: "000900006000253040030401005000006400802100000090000030009008500410000020000000007",
    s: "245987316167253948938461275351796482872134659694825731729318564416579823583642197",
    d: -1383,
  },
  {
    p: "200000500706840100100000070000029030000010090090080600004001000321000000000500007",
    s: "249176583756843129183952476815629734637415892492387651574291368321768945968534217",
    d: -1383,
  },
  {
    p: "209500000010000480000000050400002900000045007008007000000060390003010008700009010",
    s: "249586731615973482837421659471832965396145827528697143152768394963214578784359216",
    d: -1383,
  },
  {
    p: "000160480000004900009070005040000000098003000507006002005000020710040000000730000",
    s: "253169487871254936469378215142587693698423571537916842385691724716842359924735168",
    d: -1383,
  },
  {
    p: "250310000009007002074080000000008001300020608040000307013000000600000900000800000",
    s: "256319874839457162174682539762538491391724658548196327413975286687243915925861743",
    d: -1383,
  },
  {
    p: "050034608000060000090570000103000500070000400400020009700000900000400300000008017",
    s: "257134698341869725698572143183946572972385461465721839716253984829417356534698217",
    d: -1383,
  },
  {
    p: "200360009008090500009000021000170002000030000000204080003000100705000900100000006",
    s: "257361849418792563369845721546178392872639415931254687683927154725416938194583276",
    d: -1383,
  },
  {
    p: "000400000030002000614000008001094080700000032000000009400200350000057000000609100",
    s: "258471963937862541614935278321794685795186432846523719479218356162357894583649127",
    d: -1383,
  },
  {
    p: "000000070600004000100750060080069040060380000007000000002040001035100007000000530",
    s: "258631974673924158149758362581269743964387215327415896792543681835196427416872539",
    d: -1383,
  },
  {
    p: "000009130306000000090210008000000020470060000500100076000002600080000007000090045",
    s: "258679134316485792794213568861957423472368951539124876145732689983546217627891345",
    d: -1383,
  },
  {
    p: "050000001400100809010800060601900700030000000090000420000060230000001000000045900",
    s: "258697341463152879719834562641923785532478196897516423185769234924381657376245918",
    d: -1383,
  },
  {
    p: "200700010030000590801504000760130000000000746000000001002980000000000002005000008",
    s: "259763814436218597871594623764135289513829746928647351342986175687451932195372468",
    d: -1383,
  },
  {
    p: "001009004000000060039017000006005000000720090000000508302800000800070000050901300",
    s: "261589734578432169439617825786395241145728693923164578392856417814273956657941382",
    d: -1383,
  },
  {
    p: "000000008001070200070000100400010009510008020000046000040002500600005300900030010",
    s: "264351978891674235375829146482513769516798423739246851143962587627185394958437612",
    d: -1383,
  },
  {
    p: "200008000810400070090010003009000085072000600600004020000000000100600004040701000",
    s: "265378491813496572794512863439267185572183649681954327327845916158629734946731258",
    d: -1383,
  },
  {
    p: "000900340048300002009006007700000901000000400010002000500030000600097010002000030",
    s: "267981345148375692359426187726843951835719426914652873591234768683597214472168539",
    d: -1383,
  },
  {
    p: "000000405030004000000238007000040006706000200400709080000005900090000000020801040",
    s: "268917435137654829549238617983142576716583294452769381371425968894376152625891743",
    d: -1383,
  },
  {
    p: "000840030005062007000000008002580004000000700043600000807000020500007000106000500",
    s: "271849635485362197369715248712583964658294713943671852837956421594127386126438579",
    d: -1383,
  },
  {
    p: "200000030090027000340000017008100000007002308004000050000006041602000000000058000",
    s: "275614839891327465346895217538169724167542398924783156789236541652471983413958672",
    d: -1383,
  },
  {
    p: "200030000000000720481900300000300006000016400000000000700290003008600000904080100",
    s: "276135948539468721481927365197342856852716439643859217715294683328671594964583172",
    d: -1383,
  },
  {
    p: "006040590300000600080607042400020030029016007050000000010800000900000000700000000",
    s: "276143598394285671581697342467528139829316457153974286615839724942751863738462915",
    d: -1383,
  },
  {
    p: "070000350000002007000009060900010008605000010007000003009020100300740000004060002",
    s: "276184359193652487548379261932416578685237914417598623769823145321745896854961732",
    d: -1383,
  },
  {
    p: "006000980100000005053190702060380090009200000807000000000600000000000350020004000",
    s: "276543981198726435453198762562387194349251876817469523931675248684912357725834619",
    d: -1383,
  },
  {
    p: "270000100108050000000700804000370000001008020000160400000600000050000067090005002",
    s: "279834156148956273563721894425379681631548729987162435312697548854213967796485312",
    d: -1383,
  },
  {
    p: "070051600300020150000004200000500000000090310000007400012070000500000083004008000",
    s: "279851634348629157165734298621543879487296315953187462812375946596412783734968521",
    d: -1383,
  },
  {
    p: "200004607000008004000100000309000200008050409100400000800503000000000790030002060",
    s: "285934617791268534463175928349687251628351479157429386876593142512846793934712865",
    d: -1383,
  },
  {
    p: "206370001005000040070601000004080039100005060002000100000000000000000083000093070",
    s: "286374591315928746479651328754186239193245867862739154538467912947512683621893475",
    d: -1383,
  },
  {
    p: "006000050000000600100900700003800000000007500490000003802509030005100860000006040",
    s: "286714359759328614134965728513892476628437591497651283862549137945173862371286945",
    d: -1383,
  },
  {
    p: "000000043040018000105020090000409700860000500000080900010062008300050000600000000",
    s: "286795143947318625135624897521439786869271534473586912714962358392857461658143279",
    d: -1383,
  },
  {
    p: "000040006403000080600090400020300009000075030000004000005060008872000000010009500",
    s: "287143956493657281651298473528316749164975832739824165945762318872531694316489527",
    d: -1383,
  },
  {
    p: "000700010060800009000900005000000750040020100507409000600300008070000500802000300",
    s: "289745613165832479734916285926183754348527196517469832651374928473298561892651347",
    d: -1383,
  },
  {
    p: "000061534170000800000089010920410003800006000000002060000500000000000400008090000",
    s: "289761534173254896564389217926415783835976142741832965312548679697123458458697321",
    d: -1383,
  },
  {
    p: "000000000080010200030078000002009470009050000000020306000030180400000002007005604",
    s: "291543768785916243634278519162389475379654821548721396956432187413867952827195634",
    d: -1383,
  },
  {
    p: "090065004006000000000000057860030000005400008100020700000000000350008019089000020",
    s: "293765184576184932418293657867539241925417368134826795641952873352678419789341526",
    d: -1383,
  },
  {
    p: "005700001000020530010000000030050017000081005008070200000000003004009000709006020",
    s: "295763481647128539813495672436952817972681345158374296521847963364219758789536124",
    d: -1383,
  },
  {
    p: "000700004016300000050041800000000903029670000600030050000000001002400030001800000",
    s: "298756314416328795753941826175284963329675148684139257937562481862417539541893672",
    d: -1383,
  },
  {
    p: "300200490086007000000900500070000048000000200000060053150000002000320010000050700",
    s: "315286497986547321724913586573192648861435279492768153158674932647329815239851764",
    d: -1383,
  },
  {
    p: "005400000000003070890000000102000400030050000408060700020600009000200305000048100",
    s: "315476982246893571897521634172389456639754218458162793721635849984217365563948127",
    d: -1383,
  },
  {
    p: "000900740000000000000347906760180500002000080000060000000750400020000005000400120",
    s: "316925748974816253285347916763184592192573684548269371831752469427691835659438127",
    d: -1383,
  },
  {
    p: "000000050900020030024079600806000014000000506001090000000400002100000000780250000",
    s: "317864259968521437524379681856732914293148576471695328635417892142983765789256143",
    d: -1383,
  },
  {
    p: "000000690007809010020003007800740000061000003050080020000095000000000000000017540",
    s: "318574692647829315925163487832741956461952873759386124176495238594238761283617549",
    d: -1383,
  },
  {
    p: "300009020000006000067000103803040000090000002050102090600501000005400080000000007",
    s: "318759426542316879967824153823947615791685342456132798689571234275463981134298567",
    d: -1383,
  },
  {
    p: "000000087002030000000970305000009001790004003801003006000600058425000000000000000",
    s: "319546287572138694684972315253769841796814523841253976937621458425387169168495732",
    d: -1383,
  },
  {
    p: "000007405900405006000090000096000030200800000500000000010040009860200007030900800",
    s: "321687495987435126654192783196754238273861954548329671712548369869213547435976812",
    d: -1383,
  },
  {
    p: "304500000007020308000009020030105069072000000000490000000000000005048000100000047",
    s: "324581796597624318816739524438175269972863451651492873249317685765948132183256947",
    d: -1383,
  },
  {
    p: "020605000600080000000000003190000040002700000000910506080020300040000900500034008",
    s: "324695781675381492918472653196253847852746139437918526781529364243867915569134278",
    d: -1383,
  },
  {
    p: "304850100000000000005006000073100060000000019080300400000000080100409002006000503",
    s: "324857196869213754715946238973124865542678319681395427437562981158439672296781543",
    d: -1383,
  },
  {
    p: "000000090001000700670020040000730010008000000000086254900360000507100000060002000",
    s: "325417896841693725679528143256734918498251367713986254982365471537149682164872539",
    d: -1383,
  },
  {
    p: "000001000010000783840009020000200076000034800004000000080000000000000250090572040",
    s: "326781594915426783847359621138295476759634812264817935582943167473168259691572348",
    d: -1383,
  },
  {
    p: "020008000600010040740002080206000005097400000080006000000900000000305800003000201",
    s: "329648517658719342741532986236187495197453628584296173865921734412375869973864251",
    d: -1383,
  },
  {
    p: "002510000070000004090403508007000950008706000000000803000100000056000002000300090",
    s: "342518769875629314691473528217834956538796241469251873923145687156987432784362195",
    d: -1383,
  },
  {
    p: "000000500697000000000079040400800050000925000006000007000094003130080002060100000",
    s: "342618579697453218518279346423867951871925634956341827285794163134586792769132485",
    d: -1383,
  },
  {
    p: "040700000080050010050096230200900070700020004000840000000000000016000592000000100",
    s: "342718965689253417157496238264935871798621354531847629425169783816374592973582146",
    d: -1383,
  },
  {
    p: "000200560008000000000640700500860090471050003000000000000030002610000000800094010",
    s: "347289561168375429259641738532867194471952683986413275794136852613528947825794316",
    d: -1383,
  },
  {
    p: "347000900000709010000030025000001000024900607006080000200104000050000000008000004",
    s: "347512968582769413619438725875641239124953687936287541293174856451896372768325194",
    d: -1383,
  },
  {
    p: "308000609700009000000805700012000000050020030600001800000062004000000078007900000",
    s: "348217659725639481196845723412378965859426137673591842581762394964153278237984516",
    d: -1383,
  },
  {
    p: "000000000008400071001002005000759040006000050002060080015000009607000000090300600",
    s: "349517862528496371761832495183759246976248153452163987815624739637981524294375618",
    d: -1383,
  },
  {
    p: "050700000690040000040000010208000900900060004000020601400050000000300002070910003",
    s: "351786429692143758847295316268431975915867234734529681423658197189374562576912843",
    d: -1383,
  },
  {
    p: "350001090800000003001049007008005010000200000096000008900004000000050000047060050",
    s: "354781692879526143261349587728635914413298765596417238935174826682953471147862359",
    d: -1383,
  },
  {
    p: "050047000007000100100002090430000006080006000001080000000008703006009010200000058",
    s: "359147682627893145148652397435921876982476531761385429594218763876539214213764958",
    d: -1383,
  },
  {
    p: "000000415100000200070003000600020080008100500400007300000501003020340000800900000",
    s: "362789415189654237574213698637425189298136574415897362946571823721348956853962741",
    d: -1383,
  },
  {
    p: "000008070050090100000057480070015000002000000900300060603070000000009000409806000",
    s: "364128975758493126291657483876915342132764859945382761683571294517249638429836517",
    d: -1383,
  },
  {
    p: "000009070204000091801020006010360008000000000530800002059004000400750000000000000",
    s: "365189274274536891891427536912365748648972315537841962759214683486753129123698457",
    d: -1383,
  },
  {
    p: "000190002080000059000000030800427000600800500003000000000270604506000810070000000",
    s: "365194782487362159219758436851427963642839571793516248138275694526943817974681325",
    d: -1383,
  },
  {
    p: "065000000000000310409800500000900607000012050040080020100003900958000000070000000",
    s: "365721894782459316419836572231945687897612453546387129124573968958264731673198245",
    d: -1383,
  },
  {
    p: "000502004910004005000060000001050000030010407096000083800620000053000000000000001",
    s: "367592814912784365485163972741358296238916457596247183874621539153479628629835741",
    d: -1383,
  },
  {
    p: "300000800500010000190570006000000942000005000200089000002000008700002000006400091",
    s: "367924815528316479194578326685731942971245683243689157452193768719862534836457291",
    d: -1383,
  },
  {
    p: "000700940004300070200000000100002600600005780800190403035060000000000800001000000",
    s: "368721945514389276279654318143872659692435781857196423435268197926517834781943562",
    d: -1383,
  },
  {
    p: "360000000085049003000000960000201000020000108078000006000000000003050709097000080",
    s: "369127854785649213241538967936281475524763198178495326852974631613852749497316582",
    d: -1383,
  },
  {
    p: "300190000098500006000740500000000900010075080000080020230010000001000200000000609",
    s: "375196842498523176162748593827431965619275384543689721236917458951864237784352619",
    d: -1383,
  },
  {
    p: "080400000000058000040200001810900020000000004006010370900600150000002600005700000",
    s: "381479265692158743547263981813947526759326814426815379978634152134582697265791438",
    d: -1383,
  },
  {
    p: "000040071090800004006000005000000080200010000008570090800300000030000748410000030",
    s: "382645971591827364746139825953462187274918653168573492827394516639251748415786239",
    d: -1383,
  },
  {
    p: "000000040000100900070060508920007000001000250600014700003000087800000090000020100",
    s: "382975641546182973179463528924537816731896254658214739213659487865741392497328165",
    d: -1383,
  },
  {
    p: "300000000700809000021000450090000801000500097000307020000050200649000000050000080",
    s: "384125769765849312921673458597462831432581697816397524178956243649238175253714986",
    d: -1383,
  },
  {
    p: "080070004002003000154000200000000000000025700600004100001060000006090005003500890",
    s: "389172564762453981154986237435719628918625743627834159591368472846297315273541896",
    d: -1383,
  },
  {
    p: "091006800470500000000000000030000090000210000780004060206039004000040010900002000",
    s: "391476825478521639625983147134765298569218473782394561216839754853647912947152386",
    d: -1383,
  },
  {
    p: "300000206040900030080100000005001004008070600006050000050400000000020009000709801",
    s: "391587246547962138682143597725691384938274615416358972859416723173825469264739851",
    d: -1383,
  },
  {
    p: "000706000200000500060023000100000005000000040680090000002060800070501020903800070",
    s: "391756284247189536568423197134278965729615348685394712412967853876531429953842671",
    d: -1383,
  },
  {
    p: "000000014480030700006140000700900060050800300609005000000500000205000007000007009",
    s: "392758614481639725576142983738924561154876392629315478917583246265491837843267159",
    d: -1383,
  },
  {
    p: "000000800001089050700023040506090003027500000008000090000000710009060000040002000",
    s: "394751826261489357785623941516894273927536184438217695652348719879165432143972568",
    d: -1383,
  },
  {
    p: "090070510700003400205000300000008070100000002620000048010000200000600000056300000",
    s: "394872516781563429265194387549218673138746952627935148913487265472659831856321794",
    d: -1383,
  },
  {
    p: "390004000000037001000290840000560004200001000004800700900000000763000000002000500",
    s: "395184672428637951617295843179563284286741395534829716951372468763458129842916537",
    d: -1383,
  },
  {
    p: "305048000001000000000079600050060107800000020400002009500300000008020000000000416",
    s: "395648271671253948284179653952864137836791524417532869549316782168427395723985416",
    d: -1383,
  },
  {
    p: "006000018000400000000000562520170000010080005000000080940000000207060090100009070",
    s: "396257418852416937471938562528173649719684325634592781943721856287365194165849273",
    d: -1383,
  },
  {
    p: "390000000200070064010600000000400080001000503000700000023006000040890026000000130",
    s: "396524871258371964417689352932415687871962543564738219723156498145893726689247135",
    d: -1383,
  },
  {
    p: "000005081600048070400007002045000100000300000009280700070000000003000208010000030",
    s: "397625481652148379481937652845796123726351894139284765278513946563479218914862537",
    d: -1383,
  },
  {
    p: "307000510000010690040000008065200900002000070000309020000061000000000700003807000",
    s: "397682514258413697641795238165278943932146875784359126479561382826934751513827469",
    d: -1383,
  },
  {
    p: "300000052170000080050097000009300000000470603000609000034000007000056010020000000",
    s: "398164752176532489452897136769325841215478693843619275634981527987256314521743968",
    d: -1383,
  },
  {
    p: "300000000050801009007009003000796004200000680000000000003080000800024060500003090",
    s: "398472516652831479417659823185796234249315687736248951963587142871924365524163798",
    d: -1383,
  },
  {
    p: "010080000003000106000007400007000904081053000004700000200800000000005000350026007",
    s: "412689735793542186865317429537268914981453672624791358276834591148975263359126847",
    d: -1383,
  },
  {
    p: "010900000700000000000420000090050600020010390000300008560000930007040050008100020",
    s: "412983567789561243356427189193854672824716395675392418561278934237649851948135726",
    d: -1383,
  },
  {
    p: "000000002000000006002740903048003000057026000000000057305000600001080000000900380",
    s: "413659872879132546562748913148573269957426138236891457385217694691384725724965381",
    d: -1383,
  },
  {
    p: "010800007000003402000000063045010000700056900001207000000080000000004200009000180",
    s: "413862597896573412527491863345918726782356941961247358274189635158634279639725184",
    d: -1383,
  },
  {
    p: "000000000060000051008010740091000000002005600004700500030460270000870000000090003",
    s: "413957826967284351258316749591628437372145698684739512839461275125873964746592183",
    d: -1383,
  },
  {
    p: "006009020000004790700008004900300000020085300000100000001020500800040006000603000",
    s: "416739825382564791759218634948376152127485369563192487691827543835941276274653918",
    d: -1383,
  },
  {
    p: "010300600000060070000001008830000502050000000000640000200900003700058100549000000",
    s: "418327695925864371376591248834719562657283914192645837281976453763458129549132786",
    d: -1383,
  },
  {
    p: "409020085007000006026400000000040050005000700802090000000000009000032107200010000",
    s: "419627385387159246526483971793241658145368792862795413631574829954832167278916534",
    d: -1383,
  },
  {
    p: "409007020000002010000000005800530000301060097000000000000000100040709200060105040",
    s: "419657328735892614286413975897531462351264897624978531572346189143789256968125743",
    d: -1383,
  },
  {
    p: "020007030003000608000109000500004000000790000064080009000072001006000804007050000",
    s: "421867935793245618685139247579324186812796453364581729938472561256913874147658392",
    d: -1383,
  },
  {
    p: "003000009908026000006041000075800030000000450600010020104000005030050200000000000",
    s: "423785619918326547756941382275864931381297456649513728194632875837159264562478193",
    d: -1383,
  },
  {
    p: "020003670001000400030040001072000890000020000000000003090605000700900005800001006",
    s: "425813679981567432637249581372156894549328167168794253294635718716982345853471926",
    d: -1383,
  },
  {
    p: "400900015000640007000000080053000000002010000000308200006000300900000800100030549",
    s: "427983615381645927569127483853762194692514738714398256246859371935471862178236549",
    d: -1383,
  },
  {
    p: "008053600900002000030000000702008000081400200600070030140005900200000000000090060",
    s: "428753691916842753537916428792538146381469275654271839143625987269387514875194362",
    d: -1383,
  },
  {
    p: "030200070000000560120080300000050007000000280000120050000040890080900003007060000",
    s: "435296178879431562126587349912854637543679281768123954351742896684915723297368415",
    d: -1383,
  },
  {
    p: "400600800002000000908000367059040001004008200020001003000002005000060090000003000",
    s: "435617829762839514918425367359246781174398256826571943697182435583764192241953678",
    d: -1383,
  },
  {
    p: "430072900701000000000800000000037006009000547000010000000059001040003702002000000",
    s: "436572918781396254925841673854937126319628547267415839673259481548163792192784365",
    d: -1383,
  },
  {
    p: "030500090801000200000300000090720300070000009000800020600900074003008600005000010",
    s: "437582196861497235529316487194725368278631549356849721612953874943178652785264913",
    d: -1383,
  },
  {
    p: "030007006206000800070004000000000200307910008940000000800056010000103000000400020",
    s: "438297156296531847175864392681345279357912468942678531824756913569123784713489625",
    d: -1383,
  },
  {
    p: "038900000000000000207300100000030091070000508000210000580402000000000000043009720",
    s: "438921657916857342257346189864735291172694538395218476581472963729563814643189725",
    d: -1383,
  },
  {
    p: "400008002000301809008079003000000000803000005010000400005020010060017000000600007",
    s: "439568172627341859158279643294856731873194265516732498785423916362917584941685327",
    d: -1383,
  },
  {
    p: "009600000201000003860090000000000806103050200070001040300000500005408900000000008",
    s: "439615782251784693867293154592347816143856279678921345384169527725438961916572438",
    d: -1383,
  },
  {
    p: "000000800700300006306400000000071000075000360000002005003004600200000001908007050",
    s: "451726839729385146386419527632571984175948362894632715513294678267853491948167253",
    d: -1383,
  },
  {
    p: "453002000000570001080006004010000406004005000200000300002300000700800000006000108",
    s: "453182679629574831187936524918723456374615982265498317892361745741859263536247198",
    d: -1383,
  },
  {
    p: "000000002000490031102000008009048003006050700570000000008005000000063020060000007",
    s: "453681972687492531192537468219748653836259714574316289928175346741963825365824197",
    d: -1383,
  },
  {
    p: "400760020010000000008000507000000009000600000900081750041300000020500031630000000",
    s: "453769128716852394298143567185237649374695812962481753541328976829576431637914285",
    d: -1383,
  },
  {
    p: "050000000000073000008046000002014860004000050090000200300000080900050610600000029",
    s: "453829176269173548718546392532914867874362951196785234321697485947258613685431729",
    d: -1383,
  },
  {
    p: "000200900381050000000060001040702050002003007900000000000007020824005600000000009",
    s: "456271938381459762297368541148792356562143897973586214619837425824915673735624189",
    d: -1383,
  },
  {
    p: "006012900001496000000000400080000009502000000300001006167050004040000200900000000",
    s: "456812937731496582298375461684723159512689743379541826167258394843967215925134678",
    d: -1383,
  },
  {
    p: "000001063907600000000040000700000005843006017010400200024000000105000080000500000",
    s: "458921763937685124261743859792138645843256917516479238324867591175392486689514372",
    d: -1383,
  },
  {
    p: "000000600103408000000050000960000700700006080030002000510209400000000900004300507",
    s: "458927613173468295629153874961834752742516389835792146516279438387645921294381567",
    d: -1383,
  },
  {
    p: "400200800000000590007000006200030000010050007000904000048009600000000000090605281",
    s: "459216873631478592827593416286137954914852367375964128148729635562381749793645281",
    d: -1383,
  },
  {
    p: "000005000800604200027000000012070040004000038000009600000290000048000006050000890",
    s: "461725983839614275527983461312876549694152738785349612176298354948537126253461897",
    d: -1383,
  },
  {
    p: "060000000080000040030604580000005004010002705000000001004120300009000000800400072",
    s: "465287913987531246231694587798315624316842795542976831674128359129753468853469172",
    d: -1383,
  },
  {
    p: "060000090000906100100000072309000010000050000000708000070100200603400007020060080",
    s: "467215893832976145195843672359624718786351429241798536578139264613482957924567381",
    d: -1383,
  },
  {
    p: "400800030509070000012000095005080640906030000000009000000700000000003104000002060",
    s: "467895231539271486812346795325187649976534812184629357641758923258963174793412568",
    d: -1383,
  },
  {
    p: "060200009003080400091000030020007004010002056806000000000730000070000000000048900",
    s: "468213579753689421291574638925867314317492856846351792189736245674925183532148967",
    d: -1383,
  },
  {
    p: "068000070005780304030010000800360900000000405100070000000850000201000090000002000",
    s: "468523179915786324732914856824365917673291485159478632347859261281647593596132748",
    d: -1383,
  },
  {
    p: "000108007800000900030000400000020000040007209003500000207865000000000000601094500",
    s: "469158327875243961132976485716429853548637219923581746297865134354712698681394572",
    d: -1383,
  },
  {
    p: "001002069035001020080003000700000840000008005050000037000030600920000000000096000",
    s: "471582369635941728289673154792315846364728915158469237517834692926157483843296571",
    d: -1383,
  },
  {
    p: "400000000800063020010000084000300600200100000049700200030080005001000070007640000",
    s: "472819356895463721316572984758324619263198547149756238934287165681935472527641893",
    d: -1383,
  },
  {
    p: "003000200800007036500090000900000087004000051050000600010000000000018000039270400",
    s: "473681295892547136561392874926154387384726951157839642718463529245918763639275418",
    d: -1383,
  },
  {
    p: "400810509000300000000590042009080034000000080000036000005700900030000006700000400",
    s: "473812569952364817816597342629185734341279685587436291165743928234958176798621453",
    d: -1383,
  },
  {
    p: "005020000000003004900000060260050840010004009000007021000000007020000300103709000",
    s: "475126938682593714931478265267951843518234679349687521896342157724815396153769482",
    d: -1383,
  },
  {
    p: "000000290000980506000014000800000004602003000100000700089000010001620850006000000",
    s: "478356291213987546965214378837561924692743185154892763789435612341629857526178439",
    d: -1383,
  },
  {
    p: "000000100000900007206100850000603000840000000003005010310850002000000000054070060",
    s: "478532196135968427296147853529613784841729635763485219317856942682394571954271368",
    d: -1383,
  },
  {
    p: "070000000000080009020000400014000000507040000980000100800062004600100500000390068",
    s: "479236851165487329328915476214859637537641982986723145893562714642178593751394268",
    d: -1383,
  },
  {
    p: "409000000000010070800370200000007000030000090600005340900006005700400130080000600",
    s: "479562813352814976861379254148937562235641798697285341913726485726458139584193627",
    d: -1383,
  },
  {
    p: "000090050003002000050300000000000140000001206000970300605040000700203000009016070",
    s: "482197653963452718157368924398625147574831296216974385625749831741283569839516472",
    d: -1383,
  },
  {
    p: "402000000000000540060000008000020050750090360900064000009003000040102000000056200",
    s: "482615937197238546365749128618327459754891362923564781279483615546172893831956274",
    d: -1383,
  },
  {
    p: "000030000100040600020005003000090076300000090500001000000069050004080900052007800",
    s: "485236719137948625629175483241893576378654192596721348813469257764582931952317864",
    d: -1383,
  },
  {
    p: "000000069010600020072408000000007003530000000007001000920700000001060400700004500",
    s: "485312769319675824672498315146827953538946271297531648924753186851269437763184592",
    d: -1383,
  },
  {
    p: "405060007130004000000900800078230000000000308001000090000000000210670000006000530",
    s: "485362917139784652627951843578239164942516378361847295854193726213675489796428531",
    d: -1383,
  },
  {
    p: "000000030200008190090302004835000009000000008000010000306000400010005000004700083",
    s: "487196235263548197591372864835624719172953648649817352356289471718435926924761583",
    d: -1383,
  },
  {
    p: "000020090010004020065000000756200004000070080000030002070085000030007006000900008",
    s: "487623591319854627265719843756298134123476985894531762672385419938147256541962378",
    d: -1383,
  },
  {
    p: "000000000810000250063029000008036000000010007005000084300690000240500090000000008",
    s: "492158376817364259563729841978436512624815937135972684381697425246581793759243168",
    d: -1383,
  },
  {
    p: "402000000800005907600800040001004700005602000000190005500000080006000000009008060",
    s: "492371856813465927657829143361584792975632418248197635524716389186953274739248561",
    d: -1383,
  },
  {
    p: "000070085070050001300900060807010500001000000030020000006300000000000090054180600",
    s: "492671385678253941315948762867419523241536879539827416726394158183765294954182637",
    d: -1383,
  },
  {
    p: "093007006007005900000010400900300000200060007080200601000001048000000200000500010",
    s: "493827156617435982528916473961378524235164897784259631352691748149783265876542319",
    d: -1383,
  },
  {
    p: "090070520100080470000039001500046000040000080030000000200007190600500000007000000",
    s: "498671523163285479725439861571846932942713685836952714254367198619528347387194256",
    d: -1383,
  },
  {
    p: "000000800800500024030607000260300000000050410100000390000060000070200080905800000",
    s: "516492837897531624432687159269314578783956412154728396328169745671245983945873261",
    d: -1383,
  },
  {
    p: "010004070209008003000000906625000000300000005007010090000300000002000057940070000",
    s: "516934278279168543834752916625897134391246785487513692758321469162489357943675821",
    d: -1383,
  },
  {
    p: "000000000008015200000009175005001603900802001000070009080400000004067000006000000",
    s: "517234986698715234342689175875941623963852741421376859189423567254167398736598412",
    d: -1383,
  },
  {
    p: "000400082003020004000000000800009701006750000090000000200100070070640050069000030",
    s: "517436982683927514942815367835269741126754893794381625258193476371648259469572138",
    d: -1383,
  },
  {
    p: "000000003602300091000600000020084300050000000940705000107009008300810500000000000",
    s: "519247683672358491438691725721984356856123974943765812167539248394812567285476139",
    d: -1383,
  },
  {
    p: "519740060800000000040600007700003002000000015003000000401060070060000000000058400",
    s: "519742863876935124342681957795413682624897315183526749451369278968274531237158496",
    d: -1383,
  },
  {
    p: "000076004080000003007900000600007800018000040009420005346002018000000000000000200",
    s: "523176984981245673467983521654317892218659347739428165346592718892731456175864239",
    d: -1383,
  },
  {
    p: "520600000070000052000280000305020070000009010400700090003090804050800020000000000",
    s: "524637981678914352139285746395421678287369415461758293713592864956843127842176539",
    d: -1383,
  },
  {
    p: "020093000700000000000280005840100002205000010010600090008030000070060008009000007",
    s: "524793681781546923963281745846159372295374816317628594158437269472965138639812457",
    d: -1383,
  },
  {
    p: "000908006100600040300700010470000280000002400000000700200051000980000000005040020",
    s: "524918376197635842368724519471596283839172465652483791246851937983267154715349628",
    d: -1383,
  },
  {
    p: "006000004907400001000070806000069073370000000000800500009500100000020930040000000",
    s: "526318794987456321431972856158269473372145689694837512269583147715624938843791265",
    d: -1383,
  },
  {
    p: "500400000900600010100007029000000004040030068001000000030900000000050670000876090",
    s: "527491386984623517163587429378269154249135768651748932736912845892354671415876293",
    d: -1383,
  },
  {
    p: "020100000007200100000004805005003060000000000490000030760080900904602000000001400",
    s: "528139647647258193139764825285913764371546289496827531763485912914672358852391476",
    d: -1383,
  },
  {
    p: "000000090170004008409000056080040300000500009002700040350680401000007000000000000",
    s: "528361794176954238439872156985146372743528619612793845357689421894217563261435987",
    d: -1383,
  },
  {
    p: "520019000000400090000500800096040007050702010040000050002030000000800009070000300",
    s: "528619734761483592934527861196345287853792416247168953482936175315874629679251348",
    d: -1383,
  },
  {
    p: "001000000040010090800000507000090004620008000090000385400007031000000200150030000",
    s: "531879462247516893869423517318795624625348179794261385482657931973184256156932748",
    d: -1383,
  },
  {
    p: "500170008000003200200500000000800460100040900000006005820005000000084009700900000",
    s: "534172698981463257267598143372859461156347982498216375829635714613784529745921836",
    d: -1383,
  },
  {
    p: "000000078020100000907005000400000500301402700009000000080201050200300000000900306",
    s: "534629178628137495917845632462793581351482769879516243783261954296354817145978326",
    d: -1383,
  },
  {
    p: "536004100002000400000070000820000001100000390090003000000706050400059007000001000",
    s: "536984172782135469941672583823597641174268395695413728319726854468359217257841936",
    d: -1383,
  },
  {
    p: "030200160900004500008000000000080400400000310100000090006040000050007820820030000",
    s: "537298164961374582248615739692183475485729316173456298716842953354967821829531647",
    d: -1383,
  },
  {
    p: "507002080000190020009000000000000000013060008800400056050000001961370000070000000",
    s: "537642189486193527129857634645789312713265498892431756354926871961378245278514963",
    d: -1383,
  },
  {
    p: "500026400926001000000000000090000030002010507000008029000047190700000000003000080",
    s: "537926418926481375841735962695274831382619547174358629268547193719863254453192786",
    d: -1383,
  },
  {
    p: "030010740002890005090400600061009000000000060900050800000008070725000000000000030",
    s: "538216749642897315197435682261789453853142967974653821316928574725364198489571236",
    d: -1383,
  },
  {
    p: "000000061007031900000750002002500070086000050090006200000020600800009040000007000",
    s: "538942761247631985961758432412593876786214359395876214174325698823169547659487123",
    d: -1383,
  },
  {
    p: "500006108702000900000000060200000010000003084000401036104007002000000000650080000",
    s: "539746128762318945481529367243865719916273584875491236194637852328954671657182493",
    d: -1383,
  },
  {
    p: "500760002000090700100000900050600000000340009400020080000000147004003008600000030",
    s: "539764812842195763167832954953678421286341579471529386325986147714253698698417235",
    d: -1383,
  },
  {
    p: "500004600000009000204000100002300080000708001390042000000006005006900200000000930",
    s: "539814672671239854284657193712365489465798321398142567923486715156973248847521936",
    d: -1383,
  },
  {
    p: "000070000023045010900002000098004007000000000002030504607000008000000900150800002",
    s: "541376289823945716976182345398514627465297831712638594637429158284751963159863472",
    d: -1383,
  },
  {
    p: "001000006902030040800402000000067900600100008050304000069000000080700020000003000",
    s: "541978236972536841836412795213867954694125378758394162369251487185749623427683519",
    d: -1383,
  },
  {
    p: "002006000060705304000041000030000500001000620084100007090280010000000000005004000",
    s: "542836179169725384873941256237698541951473628684152937396287415428519763715364892",
    d: -1383,
  },
  {
    p: "000070000008000201230400000000807400305610000060000000900040170020009800004050000",
    s: "549271683678593241231486597192837465385614729467925318956348172723169854814752936",
    d: -1383,
  },
  {
    p: "001007900200000007009000000006000100400130090070080004800020500000060300005310008",
    s: "561847923234691857789253416396472185458136792172985634813724569927568341645319278",
    d: -1383,
  },
  {
    p: "000800000180740006970100400000000000010000004806300200605000930090000080300010000",
    s: "564892173182743596973156428439521867217968354856374219645287931791435682328619745",
    d: -1383,
  },
  {
    p: "004080031003002000000060008401000900076000002000000480000730000900600300020050100",
    s: "564987231783142659192365748451278963876493512239516487615739824948621375327854196",
    d: -1383,
  },
  {
    p: "000000040000600005031080020000806000090002000800405902087010000000000000920050803",
    s: "568923741279641385431587629752896134694132578813475962387219456145368297926754813",
    d: -1383,
  },
  {
    p: "060001080020006500000500300802100050000080070000000400406000027000360009090800000",
    s: "569231784328746591714598362842173956651489273973652418436915827285367149197824635",
    d: -1383,
  },
  {
    p: "001064003002003067000790005030000002009000040706100800060000500000000000100008030",
    s: "571264983492583167683791425835649712219875346746132859368427591954316278127958634",
    d: -1383,
  },
  {
    p: "000400000010006000000050749093000427001000080600002053020070000000900600100000002",
    s: "572439861914786235368251749893615427251347986647892153426173598735928614189564372",
    d: -1383,
  },
  {
    p: "070800002000050400000000005000639020701000000090570030000006000004000083605020009",
    s: "573864912169253478842197365458639127731482596296571834387946251924715683615328749",
    d: -1383,
  },
  {
    p: "004230016800005000000000009000970400300000000008050071000302080000004000956000020",
    s: "574239816869715243132846759615978432397421568428653971741392685283564197956187324",
    d: -1383,
  },
  {
    p: "000400000900051020000000000000000207007380090013000080090007100038010050002800004",
    s: "576423819984751623321968745859146237647382591213579486495237168738614952162895374",
    d: -1383,
  },
  {
    p: "000001200004900150300000080000005049400003002010007800030000000000750000009032004",
    s: "578341296624978153391526487863215749457893612912467835235684971146759328789132564",
    d: -1383,
  },
  {
    p: "000000003600000000000081025010940300360002000407000000002010000000030508705800400",
    s: "581629743624753189973481625218945367369172854457368291842517936196234578735896412",
    d: -1383,
  },
  {
    p: "001000400609020000004010057400000209050000006930600004000083000000960000000000905",
    s: "581736492679425183324819657467158239152394876938672514296583741745961328813247965",
    d: -1383,
  },
  {
    p: "002300004300500008000108000910200000070003010000480000058000000000060870020004300",
    s: "582379164391546728467128539916257483874693215235481697658732941143965872729814356",
    d: -1383,
  },
  {
    p: "080010000007020401020400809070300005005000006000008270008000030000690000000002100",
    s: "584916723397825461126437859271364985845279316639158274958741632712693548463582197",
    d: -1383,
  },
  {
    p: "500407002006000480001600000000900000075008304020060059000000007000500100000000023",
    s: "589417632736259481241683975463975218975128364128364759312846597897532146654791823",
    d: -1383,
  },
  {
    p: "500070000040050600360000002010006020000000800400700000020003004900140083000000097",
    s: "589672431241359678367814952815436729673921845492785316728593164956147283134268597",
    d: -1383,
  },
  {
    p: "590004600000010400060070008270009000000002090080500001820600700000000049000000200",
    s: "591284673738916452462375918275139864143862597689547321824691735356728149917453286",
    d: -1383,
  },
  {
    p: "590000070040100800306005000000003000000750001030000008015200090000000026002009100",
    s: "591382674247196835386475219158943762629758341734621958815267493973814526462539187",
    d: -1383,
  },
  {
    p: "000000000300060109070003080905010820000000006020080901000509270050630000000000000",
    s: "591824367382765149674193582965317824148952736723486951816549273257631498439278615",
    d: -1383,
  },
  {
    p: "000107026007040009080000010001500080000072050000000000620001070030050000400090008",
    s: "594137826217648539386925714741569283963872451852314697629481375138756942475293168",
    d: -1383,
  },
  {
    p: "000823000003007500700100000000041290009000000300006040000500803870000000000060019",
    s: "594823761183697524762154938658341297419275386327986145946512873871439652235768419",
    d: -1383,
  },
  {
    p: "000007830007300000000060207800400005920030000004050000050008000000790000040001309",
    s: "596217834217384596483965217831479625925836741674152983359648172162793458748521369",
    d: -1383,
  },
  {
    p: "090003002600200005000640000200070600041500070003004000000000000000801530906000040",
    s: "597183462614297385328645197259378614841526973763914258185439726472861539936752841",
    d: -1383,
  },
  {
    p: "000030100024000900000060250060507003072000509800020000100000300009000070000046000",
    s: "598234167624175938713968254961587423472613589835429716186792345349851672257346891",
    d: -1383,
  },
  {
    p: "500020003000000070000084150001000086070000000340050000000008302680000007200610000",
    s: "598721643413596278762384159921473586875162934346859721157948362689235417234617895",
    d: -1383,
  },
  {
    p: "610045000000000600000930800000060200300004000507003000080009000709002004000080013",
    s: "612845379893271645475936821941568237328794156567123498184359762739612584256487913",
    d: -1383,
  },
  {
    p: "000098070075000009008000600000000006080064000060000903200940000000007250100200004",
    s: "613598472475126839928473615342719586589364127761852943257941368894637251136285794",
    d: -1383,
  },
  {
    p: "000070080203081000000000001000400007001050409040098200000900060520000000070620000",
    s: "614279385293581674785364921952436817861752439347198256438915762526847193179623548",
    d: -1383,
  },
  {
    p: "010407000300000000000000025029050000704800000000610200800069702000000810030000090",
    s: "615427938392581467478936125129753684764892351583614279851369742946275813237148596",
    d: -1383,
  },
  {
    p: "010000240008700000300010900900802000002000506405000100040600000090030060000500001",
    s: "619385247258794613374216985961852374782143596435967128143628759597431862826579431",
    d: -1383,
  },
  {
    p: "019000508200600001007000000001000800070902000000007003000030000060804300085009002",
    s: "619473528238695741457128936921346857573982164846517293794231685162854379385769412",
    d: -1383,
  },
  {
    p: "000070000590000071003400005800200003070069004000007000048000006000980100060000007",
    s: "621573498594628371783491625819245763275369814436817259148752936357986142962134587",
    d: -1383,
  },
  {
    p: "620000008004000001100400570000004080000008000301000064870000090000020000439000050",
    s: "623751948754983621198462573967214385245638719381597264872345196516829437439176852",
    d: -1383,
  },
  {
    p: "600000800000000003040030007408260000090075000000009005071000032035020008000000100",
    s: "623917854187542963549836217458263791392175486716489325871694532935721648264358179",
    d: -1383,
  },
  {
    p: "000050000001890000400007502530740800006000000200000600800320006000000000740600900",
    s: "627453189351892467498167532539746821176285394284931675815329746963574218742618953",
    d: -1383,
  },
  {
    p: "607000053030024000000000001000008006150400030390070000000140000049006008000009000",
    s: "627981453531724689984563271472318596156492837398675142863147925749256318215839764",
    d: -1383,
  },
  {
    p: "600005007000080000000020001973600500000000400500000903000040080092000100701800090",
    s: "629135847137486259485729631973614528218593476564278913356941782892357164741862395",
    d: -1383,
  },
  {
    p: "020000000710000054003060900000030000800970000234006000006008500000409310000000090",
    s: "629145783718392654453867921975231468861974235234586179396718542587429316142653897",
    d: -1383,
  },
  {
    p: "000000080470502000805009000040006000000000700000004590260900800108030600900000010",
    s: "629173485473582961815469372542796138396815724781324596267941853158237649934658217",
    d: -1383,
  },
  {
    p: "000400000829005700705089100900000003080000060004600000000050001057200000000010800",
    s: "631427985829165734745389126976842513382591467514673298268954371157238649493716852",
    d: -1383,
  },
  {
    p: "000004008089060400010000020240901000068400000000000370000090080390000007000600003",
    s: "632154798589762431417389526243971865768435219951826374174593682396248157825617943",
    d: -1383,
  },
  {
    p: "030200400000100905089040200407031000508000000003006010000000500000020000700800040",
    s: "635297481274168935189345267467931852518472693923586714346719528851624379792853146",
    d: -1383,
  },
  {
    p: "000000070000030906001000054800000000040069000507010002006000008080500000310470500",
    s: "635942871478135926291687354829754613143269785567813492756391248984526137312478569",
    d: -1383,
  },
  {
    p: "600200400000930000400000031009000070000096000080000040000750213105020000000608000",
    s: "637281495518934627492567831359842176741396582286175349864759213175423968923618754",
    d: -1383,
  },
  {
    p: "008001070040703000000000602300008004810520000002000000704000050009180700060000000",
    s: "638291475245763918971845632397618524816524397452379861784932156529186743163457289",
    d: -1383,
  },
  {
    p: "030040000200090000807500009000000708006300000010205400000000603100050070008600002",
    s: "639147285251896347847532169925461738486379521713285496594728613162953874378614952",
    d: -1383,
  },
  {
    p: "009000270040009000807030000003500009100040080000012006065090030008000007900000000",
    s: "639158274541729863827634591283576419156943782794812356465297138318465927972381645",
    d: -1383,
  },
  {
    p: "002093005000007000058060010300009000561200003070000060100030407000000000000050002",
    s: "642193785913587246758462319384679521561248973279315864125836497437921658896754132",
    d: -1383,
  },
  {
    p: "040000003007806000091000600400150700509300001000600008100000000000037000020008400",
    s: "645791823237846915891523674468152739579384261312679548184265397956437182723918456",
    d: -1383,
  },
  {
    p: "040509001090006005000000260000080000904000007000010340000705002005001000301090000",
    s: "648529731192376485537148269713284596984653127256917348469735812825461973371892654",
    d: -1383,
  },
  {
    p: "000004080003000021000007000421000060030009500700000000009008300500960008040700050",
    s: "652194783973856421184237695421375869836419572795682134269548317517963248348721956",
    d: -1383,
  },
  {
    p: "600000900020480000080002300045003600000100250000700000000060531000800070009500000",
    s: "654317928923485716781692345145923687897146253236758194478269531562831479319574862",
    d: -1383,
  },
  {
    p: "600039000000000970020000006000400001000002435010700000040510800970008000100020000",
    s: "657239148831645972429871356392456781768192435514783629246517893975368214183924567",
    d: -1383,
  },
  {
    p: "009400010100080300400015000000060080000000032060807900000209000000500800700000490",
    s: "659423718127986354438715269941362587875194632263857941586249173394571826712638495",
    d: -1383,
  },
  {
    p: "009800000801500200020007000006001057000060000735000000400006803500080009000004000",
    s: "659823174871549236324617985986231457142765398735498612417956823563182749298374561",
    d: -1383,
  },
  {
    p: "000003000050010040040007605800000009009000400160080020000725001210000000000008300",
    s: "671453298958612743342897615827564139539271486164389527483725961215936874796148352",
    d: -1383,
  },
  {
    p: "002104008003007000000030040700600090090000000080400176000700300000060500000390007",
    s: "672154938413987652859236741724613895196578423385429176261745389937862514548391267",
    d: -1383,
  },
  {
    p: "000080190800000050594000300016052000000378000002000000040900601000000007007000400",
    s: "673584192821693754594721368316452879459378216782169543245937681168245937937816425",
    d: -1383,
  },
  {
    p: "070000001080160047000005080090010000057300060000000030030070000000296000240000600",
    s: "674823591385169247921745386893614725457382169162957834536478912718296453249531678",
    d: -1383,
  },
  {
    p: "000000042000008006008000150000001030700000500003207060050006080040790000001003700",
    s: "675319842219548376438672159584961237726834591193257468357126984842795613961483725",
    d: -1383,
  },
  {
    p: "005300820001200360040100500300040600500030900060000000000600070719020000000000000",
    s: "675394821981275364243168597397841652524736918168952743432689175719523486856417239",
    d: -1383,
  },
  {
    p: "000010000210700008050600200040100006307009005000000080000500001760090000500000049",
    s: "678912453213745698459683217945128376387469125126357984892534761764891532531276849",
    d: -1383,
  },
  {
    p: "600080400000094000520300100090010020030000075000700000002007008001000000060102003",
    s: "679581432813294567524376189497815326136429875285763941342957618751638294968142753",
    d: -1383,
  },
  {
    p: "600000900000000502050870300000090030100000008840700001900005000200010005008042000",
    s: "681523947379461582452879316725198634196234758843756291917685423234917865568342179",
    d: -1383,
  },
  {
    p: "002500000040007180100008000810030605005800000000001070090004000000002906070000400",
    s: "682513749549627183137498562814739625725846391963251874396184257458372916271965438",
    d: -1383,
  },
  {
    p: "600050001903080007000900200007800000140007000238006000004000830000000400010000070",
    s: "682754391953281647471963285597842163146537928238196754724615839865379412319428576",
    d: -1383,
  },
  {
    p: "000000049040079020002040600090050010000107800010000060050830000008520000100000000",
    s: "683215749541679328972348651896453217425167893317982465259834176768521934134796582",
    d: -1383,
  },
  {
    p: "000030050009052010002608003056000000000005021000800009000009000060780000040001008",
    s: "684137952379452816512698473156924387498375621723816549831249765265783194947561238",
    d: -1383,
  },
  {
    p: "005000000000107000410850000000030096020600000000019020059040100000000060206000308",
    s: "685493217392167485417852639178234596923685741564719823859346172731528964246971358",
    d: -1383,
  },
  {
    p: "600002001073004000090000786300001870000000032000540000004008600000210000007000000",
    s: "685792341173684925492135786356921874941876532728543169214358697869217453537469218",
    d: -1383,
  },
  {
    p: "005900040090004200000805000008500002000270000000000600903186400060400100200000000",
    s: "685927341791634258342815769478561932536279814129348675953186427867452193214793586",
    d: -1383,
  },
  {
    p: "007000301300001500002600000200418000900000008000700006010020090000000700490300020",
    s: "687952341349871562152643879265418937971236458834795216718524693523169784496387125",
    d: -1383,
  },
  {
    p: "600030001040190230080200000030000007200003004001506000020057000000000008500900000",
    s: "692735841745198236183264795836419527259873164471526983328657419917342658564981372",
    d: -1383,
  },
  {
    p: "693070000000035004000000600000006002000000070020400908002009000046000750001700300",
    s: "693874215217635894584291637179386542468952173325417968732569481846123759951748326",
    d: -1383,
  },
  {
    p: "000005000008000900200090046029080450400300090306010000000003504000700000040001000",
    s: "694275138718436925235198746129687453487352691356914287971823564563749812842561379",
    d: -1383,
  },
  {
    p: "090000830078604000000000004200405608800000010000026500700150000400200000000000900",
    s: "694572831178634259523981764237415698865397412941826573782159346459263187316748925",
    d: -1383,
  },
  {
    p: "600000003000916000014003007000701000000000000800000094960370800050020000070080050",
    s: "695247183387916425214853967546791238729438516831562794962375841158624379473189652",
    d: -1383,
  },
  {
    p: "000000002001006970000008500034000000900007600070050004300080007050600300060400008",
    s: "695734812841526973723918546534862791982147635176359284319285467458671329267493158",
    d: -1383,
  },
  {
    p: "000035000001000005500978300300800002080004003000000000904000010050000000010740096",
    s: "698135724731426985542978361375869142189254673426317859964583217257691438813742596",
    d: -1383,
  },
  {
    p: "000600390600200500800090000090000005050000800000460010300970000020010000087020600",
    s: "712658394639241587845397126193782465456139872278465913361974258524816739987523641",
    d: -1383,
  },
  {
    p: "000050000304600080800000020020000003530240006008000007000900000000700012001008960",
    s: "712854639354629781896173524629587143537241896148396257465912378983765412271438965",
    d: -1383,
  },
  {
    p: "003006800000007010405001000100980020024300000000070000008040590000000003002000074",
    s: "713496852286537419495821736167984325824315967359672148678243591541769283932158674",
    d: -1383,
  },
  {
    p: "010000800800735000020100070090000004200000700000009500000400003000097460509001000",
    s: "713926845864735192925148376197853624258614739436279518671482953382597461549361287",
    d: -1383,
  },
  {
    p: "709000058030800000040700300090500010060008090400000000000040506000230007001000030",
    s: "719463258536892741842751369398574612167328495425916873983147526654239187271685934",
    d: -1383,
  },
  {
    p: "000534086000000000520010000071080000300000019005000304008000000400001090000098600",
    s: "719534286863972451524816937971483562346725819285169374698347125432651798157298643",
    d: -1383,
  },
  {
    p: "710000000800000500000019030000000060100502007200730000040070002006420001000300004",
    s: "719853426832647519654219738475198263193562847268734195541976382386425971927381654",
    d: -1383,
  },
  {
    p: "700108000000000200080003470000485000500000900060070004250000003000090001000046500",
    s: "724158369395764218681923475972485136548631927163279854259817643436592781817346592",
    d: -1383,
  },
  {
    p: "000160003030800000090002784010900400200000070000000016005000000080640005000000320",
    s: "728164953534879261196352784617985432253416879849723516975231648382647195461598327",
    d: -1383,
  },
  {
    p: "000000639000870010100020000050007190070908002002040000500000400000000005680100000",
    s: "728415639965873214143629857456237198371968542892541376539782461214396785687154923",
    d: -1383,
  },
  {
    p: "020010500000800009401603000007001000000340000000005002500700046000080001000006370",
    s: "728419563635827419491653728857261934962348157143975682519732846376584291284196375",
    d: -1383,
  },
  {
    p: "008900060405000100006000029200000801000400700001806000000047090500000007004500000",
    s: "728951364495263178136784529267395841859412736341876952683147295512639487974528613",
    d: -1383,
  },
  {
    p: "000058000000000125000004300400900000003060000062500000020000907090070501608000002",
    s: "731258694846739125259614378417923856583467219962581743125346987394872561678195432",
    d: -1383,
  },
  {
    p: "030809600000700091400003005600000080000020000003004209000400000000600012085000060",
    s: "731859624258746391496213875624597183519328746873164259962471538347685912185932467",
    d: -1383,
  },
  {
    p: "000000002200001000001807009145000070300080190068000000000400000007000026006005400",
    s: "734659812289341765651827349145293678372586194968714253513462987497138526826975431",
    d: -1383,
  },
  {
    p: "000010000080004610640030090007000030006008002000050906003040001000000040008900050",
    s: "735619428289574613641832795897126534356498172124357986973245861562781349418963257",
    d: -1383,
  },
  {
    p: "030010040900700000004000270007020300080000600001007050560003008000600100010000030",
    s: "736215849928734561154986273697521384285349617341867952562173498473698125819452736",
    d: -1383,
  },
  {
    p: "003000508000390000000000702050400070400006000001028050200805403000000100000270000",
    s: "743162598528397641916584732859431276432756819671928354297815463385649127164273985",
    d: -1383,
  },
  {
    p: "040000000000003709065700010007008304580000000010000070058049000400000006200080000",
    s: "743891625821563749965724813697218354584937162312456978158649237439172586276385491",
    d: -1383,
  },
  {
    p: "040008020000070500900400010270630800000500300600000000000050008001000079000029050",
    s: "745318926136972584982465713279631845814597362653284197497156238521843679368729451",
    d: -1383,
  },
  {
    p: "700010820520038001000600400850000000000000004090500780070000000010000300000300046",
    s: "746915823529438671138627495853742169267189534491563782374256918612894357985371246",
    d: -1383,
  },
  {
    p: "006000000080070460053600001075013009002400000000000600000500000090340005000008070",
    s: "746931582981275463253684791675813249832469157419752638368527914197346825524198376",
    d: -1383,
  },
  {
    p: "000209030690004800200080070050000003070400205000000000000001000380900000406005002",
    s: "748219536695734821231586479854627913173498265962153748529341687387962154416875392",
    d: -1383,
  },
  {
    p: "708000000036097008090500004000003070000000100007000006000030005020100040054020060",
    s: "748312659536497218291586734915863472462975183387241596179634825623158947854729361",
    d: -1383,
  },
  {
    p: "000000001010000870503000400060504019004009000070260000000073004000000000856000100",
    s: "748396251619425873523817496362584719184739625975261348291673584437158962856942137",
    d: -1383,
  },
  {
    p: "700001300000500040805000100620090700300000010090000000960000007003007000080026004",
    s: "749861325216573948835249176624198753378652419591734682962415837453987261187326594",
    d: -1383,
  },
  {
    p: "050000000860001020000070000010005009047100000083009000000400300000062040000900752",
    s: "751294683869531427324876591612745839947183265583629174298457316175362948436918752",
    d: -1383,
  },
  {
    p: "050008090603002080020000003000910800005070000007060029000000600800000001002036000",
    s: "751348296693152487428697513236914875985273164147865329379481652864529731512736948",
    d: -1383,
  },
  {
    p: "751009000040000000800100460005007040300900000090008200002000000007000531000010006",
    s: "751649382643285917829173465285367149374921658196458273512736894467892531938514726",
    d: -1383,
  },
  {
    p: "700080300862000000900500010024300080000400100005007000000004950000000700008035000",
    s: "751986324862143579943572816124359687679428135385617492217864953536291748498735261",
    d: -1383,
  },
  {
    p: "750010000020008030060503000200000000107000080000460000000006090490307060000000048",
    s: "753914826921678534864523917236789451147235689589461273312846795498357162675192348",
    d: -1383,
  },
  {
    p: "704000000008000050003950200080003060605000010200070000000100040001060003000708500",
    s: "754382196928641357163957284487513962635429718219876435872135649591264873346798521",
    d: -1383,
  },
  {
    p: "704092001800000005020006009060405000009370600000000070000010890000050000003007000",
    s: "754892361896731425321546789167425938549378612238169574675214893982653147413987256",
    d: -1383,
  },
  {
    p: "701090000000680004000010609690400020000000500020000000003700450007000000900001703",
    s: "761294835539687214482315679695478321174932568328156947813769452257843196946521783",
    d: -1383,
  },
  {
    p: "000450800023007006000000090010000005400008001800005030070000000102064000004020500",
    s: "761459823923817456548632197217346985435298761896175234379581642152964378684723519",
    d: -1383,
  },
  {
    p: "000049008000000702010705040200000037050000490030007000070200009005004000008500000",
    s: "762149358549638712813725946284951637657382491931467825476213589195874263328596174",
    d: -1383,
  },
  {
    p: "002900000000006230080007609340000500090080000000600000009008005031740000600020000",
    s: "762934158954816237183257649347192586296485371815673924429368715531749862678521493",
    d: -1383,
  },
  {
    p: "700035800090840205000001000307600020000000100006000083050100006000008400400000000",
    s: "762935841193846275845721639317689524984253167526417983258174396671398452439562718",
    d: -1383,
  },
  {
    p: "000050201030000000500230609083000170004000000070090005000000520010600003600070000",
    s: "769458231832961457541237689983546172254713968176892345397184526418625793625379814",
    d: -1383,
  },
  {
    p: "781000040604001000030000000908003021000000700070090008200000089000070000000430010",
    s: "781326945624951873539847162958763421312584796476192538247615389193278654865439217",
    d: -1383,
  },
  {
    p: "080004005900010000006500040057120800000700000000053000000900020100007000230040009",
    s: "782364915945812637316579248457126893623798451891453762574981326169237584238645179",
    d: -1383,
  },
  {
    p: "003000026000300907000042000030850000009000000002010840014009075000005000000600090",
    s: "783591426245368917196742538431857269869423751572916843614289375927135684358674192",
    d: -1383,
  },
  {
    p: "000060009035002000010000008000000060302050000400000000001049073000683904000070500",
    s: "784165329635892147219734658198327465372456891456918732861549273527683914943271586",
    d: -1383,
  },
  {
    p: "080100000043000090090005070006904010400300000008020300000000000001006705000001069",
    s: "785139642143762598692845173236954817457318926918627354569273481821496735374581269",
    d: -1383,
  },
  {
    p: "000200930016000000904000000500100000000000794070003052000500403000406000607000009",
    s: "785264931216935847934781625592147386163852794478693152821579463359416278647328519",
    d: -1383,
  },
  {
    p: "000000000900030650500060000008006530300010004007000902800000300604009000010807000",
    s: "786594213941732658532168749428976531369215874157483962895641327674329185213857496",
    d: -1383,
  },
  {
    p: "000930050009008000405000080060000830000000000000064000070809001600007200020600097",
    s: "786931452239458176415276983162795834947382615358164729574829361693517248821643597",
    d: -1383,
  },
  {
    p: "709064020300000000010700900130000000002000000000010709007500000060009002050407008",
    s: "789364125325891467614752983138975246972643851546218739897526314463189572251437698",
    d: -1383,
  },
  {
    p: "000003020000000015400269030200150600001006050000400000900000007800000500003600004",
    s: "789513426632784915415269738297158643341976852568432179954821367826347591173695284",
    d: -1383,
  },
  {
    p: "700600400001004800050800100000062079000010600000009080960000000403000000020000360",
    s: "789621435631954827254837196148362579592718643376549281965483712413276958827195364",
    d: -1383,
  },
  {
    p: "090006000000702013603000000500040800000057009900000007006400002000083000007100040",
    s: "791536284845792613623814975572941836318657429964328157186475392459283761237169548",
    d: -1383,
  },
  {
    p: "702003000050490000060200000003000205009510008000027000000008053610000000000000860",
    s: "792853416851496327364271589143689275279514638586327194427168953618935742935742861",
    d: -1383,
  },
  {
    p: "003084002800012009000600000050000064009100020070060000620300070000000400004000030",
    s: "793584612846712359512693847351829764469137528278465193625348971937251486184976235",
    d: -1383,
  },
  {
    p: "700100506000608004000000030001004000040080629029000000002005078000000000105400000",
    s: "794123586213658794658749231361294857547381629829576413432965178976812345185437962",
    d: -1383,
  },
  {
    p: "004360028010200000500000006060080530900004000000600800803000000002090000000520004",
    s: "794365128316278495528419376467982531985134267231657849853746912642891753179523684",
    d: -1383,
  },
  {
    p: "700000008003600100020000475040000010069000000200960080300200890800040700000000000",
    s: "795124368483657129621893475548732916169485237237961584354276891816349752972518643",
    d: -1383,
  },
  {
    p: "096000200000000007010049500820010400600400008000002000009803050000070060080000004",
    s: "796158243548236197312749586823615479651497328974382615469823751135974862287561934",
    d: -1383,
  },
  {
    p: "700000005200009741006200000000000090009580300000043002430601900000050000000000400",
    s: "798134265253869741146275839324716598679582314581943672435621987967458123812397456",
    d: -1383,
  },
  {
    p: "090203501100006408030000200009000800000300096002700000040001600000020000007500000",
    s: "798243561125976438436158279679415823514382796382769145243891657951627384867534912",
    d: -1383,
  },
  {
    p: "000300006000007004602081000000000057100250000420000000050000000807000060203400805",
    s: "798345126531627984642981573386194257179253648425768391954816732817532469263479815",
    d: -1383,
  },
  {
    p: "800003090005060000300200084590000200000004060000350000700012008000900006060080000",
    s: "812543697945768312376291584598176243137824965624359871759612438481935726263487159",
    d: -1383,
  },
  {
    p: "802030004004050000065007001050710000000004000000006230006200000370100500000070000",
    s: "812639754734851926965427381653712498297384615148596237586243179379168542421975863",
    d: -1383,
  },
  {
    p: "810000000006008000004329060009000008500006003000070010040030000200900500908000400",
    s: "812765394396418752754329861129543678587196243463872915645237189271984536938651427",
    d: -1383,
  },
  {
    p: "002000000030500009040000071750002000300006000000090850400130500900800007100600000",
    s: "812973645637514289549268371751382496398456712264791853476139528923845167185627934",
    d: -1383,
  },
  {
    p: "003070000059000008400000003067340100000001020000007035145090700006000000200000000",
    s: "813279546659134278472568913567342189384951627921687435145893762736425891298716354",
    d: -1383,
  },
  {
    p: "000070600940000000520460000200013700060000005000000006004020010090100003008000079",
    s: "813579642946231857527468931285613794461792385379854126634927518792185463158346279",
    d: -1383,
  },
  {
    p: "003000005950130080000006000000010042040000807207300000090008600000060500000000073",
    s: "813974265956132784472586319635817942149625837287349156394758621721463598568291473",
    d: -1383,
  },
  {
    p: "804200009000104000000009003000005030201000705708000000000457000500000401009000800",
    s: "814263579395174682627589143946715238231948765758632914182457396573896421469321857",
    d: -1383,
  },
  {
    p: "010060000070100008050340200000080906500000400008000010020050000000007039900001005",
    s: "814762593273195648659348271731284956562913487498576312327859164145627839986431725",
    d: -1383,
  },
  {
    p: "800000040603100009902600780000300800000089020300000000400070600000005900001002000",
    s: "815297346673148259942653781257316894164789523398524167429871635786435912531962478",
    d: -1383,
  },
  {
    p: "800000090000001000000600130021800500003412000000500000000000045700205009208000007",
    s: "817354692362981754945627138421896573573412986689573421196738245734265819258149367",
    d: -1383,
  },
  {
    p: "000300020002800907000700010500147000008000000300002470106000000000000005080060704",
    s: "817394526632815947954726318529147683748639251361582479176453892493278165285961734",
    d: -1383,
  },
  {
    p: "009000005600000004025000308090102030100069000008000200000000082003000000570400900",
    s: "819243675637895124425617398794182536152369847368754219946531782283976451571428963",
    d: -1383,
  },
  {
    p: "000000034500010080004098200000000400200061000970000056601070005000003010700000000",
    s: "819726534527314689364598271136957428245861793978432156681279345452683917793145862",
    d: -1383,
  },
  {
    p: "020004060007002050006790000000300006004021000080000100000060003049870000000000017",
    s: "821534769397612854456798231912387546564921378783456192275169483149873625638245917",
    d: -1383,
  },
  {
    p: "800000003560000010004200800000460000030908500000020000010004050000006920603800000",
    s: "821645793569387214374219865952463187136978542487521639218794356745136928693852471",
    d: -1383,
  },
  {
    p: "000000000639002005007080690200000000000305210410007030050000000006400070100000800",
    s: "821659347639742185547183692293814756768395214415267938352978461986421573174536829",
    d: -1383,
  },
  {
    p: "000907003000025007090000100900860000540000309000000200008070006000051000004300001",
    s: "821947653463125897795638142932864715546712389187593264318479526679251438254386971",
    d: -1383,
  },
  {
    p: "003060050000002308007008240500000090000700010900024600400050000001000030086000000",
    s: "823461957145972368697538241572816493364795812918324675439257186251689734786143529",
    d: -1383,
  },
  {
    p: "004000076090000840003800900070340060006000200030000001010002080080000009200005000",
    s: "824953176591267843763814952172349568956178234438526791317492685685731429249685317",
    d: -1383,
  },
  {
    p: "020400000040310500001000700000069000030001000056004100503020009000000020000708006",
    s: "825497613647312598391685742178569234432871965956234187583126479764953821219748356",
    d: -1383,
  },
  {
    p: "800100037030000010005000200060400003000300000000007028097600000340000000608095000",
    s: "826149537934572816175863249261458793789326451453917628597634182342781965618295374",
    d: -1383,
  },
  {
    p: "020030000050020090000800000007004000400200070008100060060903005000600980500000640",
    s: "826539417753421896941876532617394258435268179298157364164983725372645981589712643",
    d: -1383,
  },
  {
    p: "000500000000020907600000020102030040000000000000074508004050006206001000080703050",
    s: "827596431415328967693147825172835649548619372369274518734952186256481793981763254",
    d: -1383,
  },
  {
    p: "000560400000000060000100730008003600000010009000004085009000000106980000084270000",
    s: "831567492497328561562149738918753624645812379723694185259436817176985243384271956",
    d: -1383,
  },
  {
    p: "031900700007500089000600040000000814400730006000001000054000000000080057000090000",
    s: "831924765647513289925678341379256814418739526562841973254367198193482657786195432",
    d: -1383,
  },
  {
    p: "830900000000007240500000000003400500000052603000000080004006020090008000085100007",
    s: "832945716961837245547261839623489571418752693759613482174596328296378154385124967",
    d: -1383,
  },
  {
    p: "004005000000380001960000300100000400005008000000901007000806000500000810307040090",
    s: "834615972752389641961274385193527468275468139648931257419856723526793814387142596",
    d: -1383,
  },
  {
    p: "000900671006308000000000900003000100000007062700450000080620004050000280100000000",
    s: "835942671916378425247561938563289147498137562721456893389625714654713289172894356",
    d: -1383,
  },
  {
    p: "000000004020089000690007000040030007050040180009706400070018000008500030000000000",
    s: "837165294421389765695427318246831957753942186189756423372618549918574632564293871",
    d: -1383,
  },
  {
    p: "840000023000028100000000094060052000902000040030700000000906000174000006090000000",
    s: "841697523359428167726531894467152389912863745538749612283976451174285936695314278",
    d: -1383,
  },
  {
    p: "040030056000080100200040730104007000008005400090000000603200000000000000005908040",
    s: "841732956937586124256149738164827593378695412592413687613254879489371265725968341",
    d: -1383,
  },
  {
    p: "000001035000000807009408000004080000560300702003602010450000000000030100000000090",
    s: "842761935615293847379458621724185369561349782983672514458916273297834156136527498",
    d: -1383,
  },
  {
    p: "040000201050109008700060000408000029030400700007000000000000000010084050000700106",
    s: "846357291352149678791862543468571329139428765527936814975613482613284957284795136",
    d: -1383,
  },
  {
    p: "800000700310000004002509000003600001000301080090000000700060050001004002204000006",
    s: "849213765315876294672549318583627941426391587197485623738162459961754832254938176",
    d: -1383,
  },
  {
    p: "800300000001005039000700001300000000900400600000602400600080204597000000004000005",
    s: "852319746761245839439768521346871952928453617175692483613587294597124368284936175",
    d: -1383,
  },
  {
    p: "002001906000008000010600078070090000080350012000046005500900000000000000097000600",
    s: "852471936769538241314629578475192863986357412231846795523964187648715329197283654",
    d: -1383,
  },
  {
    p: "000003904001800050703040002000000000100000709002080005600370000905000080300200000",
    s: "856123974241897653793645812539714268168532749472986135684379521925461387317258496",
    d: -1383,
  },
  {
    p: "007000004000150080309078000600500002008006000000040091000082000005000900230000070",
    s: "857629314462153789319478265674591832198236547523847691946782153785314926231965478",
    d: -1383,
  },
  {
    p: "000006401200800090000000000000109003006008050008540000590300040402000007100002000",
    s: "859726431274813596631954278745169823916238754328547169597381642482695317163472985",
    d: -1383,
  },
  {
    p: "800760001002090000003000089000000860090076040000050000000000090400000530010300408",
    s: "859764321162893754743512689271439865598176243634258917385647192427981536916325478",
    d: -1383,
  },
  {
    p: "000020009350070610000400500086509200000600800032000000700004000000000070008000051",
    s: "861325749354978612279461583486519237517632894932847165795184326143256978628793451",
    d: -1383,
  },
  {
    p: "061900000900106350000400000400200076000390200000007000008000010700000020640080000",
    s: "861953742924176358537428169483215976176394285259867431398542617715639824642781593",
    d: -1383,
  },
  {
    p: "000300040900800600050009000040000105010006002008050003200010090000020710600090000",
    s: "862371549937845621154269837346982175519736482728154963285617394493528716671493258",
    d: -1383,
  },
  {
    p: "802500307000000400030600080000290050600010700000004061008023000490001000000000000",
    s: "862549317975138426134672589741296853689315742253784961518923674497861235326457198",
    d: -1383,
  },
  {
    p: "860000000050063004000500000000010008007008300200000460000357200030200950000000700",
    s: "863472195952163874174589632396714528547628319281935467419357286738246951625891743",
    d: -1383,
  },
  {
    p: "865000400000060000100500000010408000709000000000900750308004002000300096600000001",
    s: "865192437934867215127543968513478629749256183286931754398614572471325896652789341",
    d: -1383,
  },
  {
    p: "000109000000080070403000800000270001079000000008006500020010460030060000080020010",
    s: "867139254592684173413752896356278941279541638148396527725813469931465782684927315",
    d: -1383,
  },
  {
    p: "009100200050200078200830006000010002000005001040020830680500000000000090003000000",
    s: "869157243351264978274839516736918452928345761145726839687591324512483697493672185",
    d: -1383,
  },
  {
    p: "009000300501090040072003060905060100100000004000080000000004907200000000000010580",
    s: "869742351531698742472153869925467138187325694346981275618534927253879416794216583",
    d: -1383,
  },
  {
    p: "071506300000000062900300800080034006000000090400007000000780010100000650090000000",
    s: "871526349345879162962341875589134726617258493423967581256783914138492657794615238",
    d: -1383,
  },
  {
    p: "801000003400001005009380000567100000000000700010058200000005800020006000600030000",
    s: "871569423436271985259384617567192348982643751314758269193425876728916534645837192",
    d: -1383,
  },
  {
    p: "000002400000580000935007000000060300007900000610040900100000003002005600080300040",
    s: "871632495264589137935417268598261374427953816613748952156894723342175689789326541",
    d: -1383,
  },
  {
    p: "071000000009003482030800000000400060090000010680002907000050800003000090000700003",
    s: "871924356569173482432865179315497268297638514684512937726359841143286795958741623",
    d: -1383,
  },
  {
    p: "003400050060080000409000030300970025004000090051000000000030708000107000500020000",
    s: "873416259265389174419752836386971425724865391951243687192534768638197542547628913",
    d: -1383,
  },
  {
    p: "000592000000030009506700000000000705060000030005007094000000028350100000017000300",
    s: "873592461421638579596714283982463715764951832135287694649375128358126947217849356",
    d: -1383,
  },
  {
    p: "004000010093000402620010000302700000061000000000005070000082740006003000000500060",
    s: "874259613193867452625314897352796184761428935948135276539682741416973528287541369",
    d: -1383,
  },
  {
    p: "000030006000700080000410700006001024002507010000000000000000500507086001094300000",
    s: "875239146341765289269418753756891324932547618418623975683174592527986431194352867",
    d: -1383,
  },
  {
    p: "800094600000000070002000003069050000700006080340200000010000000000605010020730005",
    s: "875394621134562978692178453269853147751946382348217569517489236983625714426731895",
    d: -1383,
  },
  {
    p: "800090003000708090002005000030006500140000280050004000000000610000003004000059700",
    s: "875691423364728195912345867237986541149537286658214379593472618721863954486159732",
    d: -1383,
  },
  {
    p: "000100500200000604400860270009000007600005000700000000007900020300024009080050000",
    s: "876142593291537684453869271539218467618475932724693158147986325365724819982351746",
    d: -1383,
  },
  {
    p: "000500013000400000904080600400002030590600801680000070200000000000107050000000008",
    s: "876529413125436789934781625417852936592673841683914572259348167368197254741265398",
    d: -1383,
  },
  {
    p: "800000004230000900000000150307000010400392000006005000080006000003000006600208005",
    s: "891527634235641978764983152357864219418392567926175483582436791143759826679218345",
    d: -1383,
  },
  {
    p: "890603040003000200706000000200008000580000900010030000300060001000509000040002800",
    s: "891623745453781269726495183234958617587146932619237458372864591168579324945312876",
    d: -1383,
  },
  {
    p: "000054060010002305020006000000760004730580020000000000201000000000008006370000800",
    s: "893154267617892345425376198152763984734589621968421573281637459549218736376945812",
    d: -1383,
  },
  {
    p: "090004020045100803060000005004000601000900000908200000050000400700008000001030500",
    s: "893564127245179863167823945524387691316945782978216354652791438739458216481632579",
    d: -1383,
  },
  {
    p: "800000405000030010000000080000500000420000000305000047004190700007002006902050800",
    s: "893621475746835219251947683179564328428379561365218947684193752537482196912756834",
    d: -1383,
  },
  {
    p: "804300005075090806000070000008400130000003900000000007000001700056000000010000069",
    s: "894316275375294816621875394968457132147623958532189647489561723756932481213748569",
    d: -1383,
  },
  {
    p: "000000060000780004270500300010470000600000028023000700000050600780100900009000000",
    s: "895234167361789254274516389918472536657391428423865791142958673786123945539647812",
    d: -1383,
  },
  {
    p: "000023017000090208000000500006570000907034000000006042419000060000000004500000000",
    s: "895623417764195238231748596146572983927834651358916742419287365682359174573461829",
    d: -1383,
  },
  {
    p: "800230000020070009060000170530010000009080405000000000000309840000020750000008000",
    s: "897231564125476389463895172534917628279683415618542937752369841986124753341758296",
    d: -1383,
  },
  {
    p: "800000002000041000000020375204005009000000600300004720020016090700000800000300000",
    s: "897563412532741986146928375274685139981237654365194728423816597719452863658379241",
    d: -1383,
  },
  {
    p: "002340000600010002034000096200009060040075000000000007170002009005090000000000500",
    s: "912346758658917342734528196287139465346875921591264837173452689865793214429681573",
    d: -1383,
  },
  {
    p: "002006805007009102008000070006100000100700900030400700000045030051000008000000000",
    s: "912376845347589162568214379796153284124768953835492716279845631651937428483621597",
    d: -1383,
  },
  {
    p: "000400603508000000030700090120800000000600904005000206360000700000090000000000362",
    s: "912458673578963421634712895126849537783625914495137286361284759257396148849571362",
    d: -1383,
  },
  {
    p: "906083000000020068020000090000009050300000000009700003040008007003000200200050034",
    s: "916483572537921468824576391782349156351862749469715823645238917173694285298157634",
    d: -1383,
  },
  {
    p: "910500000000000600002090000100040900207013000009800034024000007000100000860070000",
    s: "916584723475231689382796451138645972247913568659827134524369817793158246861472395",
    d: -1383,
  },
  {
    p: "000708002000060000030500096070040000008600420001000030050090000009280001160000000",
    s: "916738542285469173734521896673842915598613427421975638852197364349286751167354289",
    d: -1383,
  },
  {
    p: "016030000000000009704500006005009030309000000002750800080040000000007500000005042",
    s: "916832457258674319734591286875429631349168725162753894581246973423917568697385142",
    d: -1383,
  },
  {
    p: "000037400008004003032000087000000051003000000764003002001900000800005010000000004",
    s: "916837425578124963432659187289476351153298746764513892341962578827345619695781234",
    d: -1383,
  },
  {
    p: "920000000006004000400000706008002007300900000264000008010007800600000390030200000",
    s: "921675483786134529453829716198452637375968241264713958512397864647581392839246175",
    d: -1383,
  },
  {
    p: "900000300000209001060170000402090000700038200000020850250000000000000410030000060",
    s: "921846375347259681568173924482795136715638249693421857256314798879562413134987562",
    d: -1383,
  },
  {
    p: "900070800000009060400032500000060002005004708800000000500020000000600307032100000",
    s: "923576841758419263416832579341768952265394718897251634574923186189645327632187495",
    d: -1383,
  },
  {
    p: "020030007400070005000000010070080402240000000000900008304001600000003050600054000",
    s: "926135847431278965785469213179586432248317596563942178354721689812693754697854321",
    d: -1383,
  },
  {
    p: "900000000504070600000065029000040200002600010005809700400006000300000008000400030",
    s: "926184357534972681871365429683741295792653814145829763418536972369217548257498136",
    d: -1383,
  },
  {
    p: "900001304000092160004000000000007000405030900000600001063000780000000620002080000",
    s: "926871354357492168184563297638917542415238976279645831563124789841759623792386415",
    d: -1383,
  },
  {
    p: "000500000000090008680007905009070000500102000102080050090034000760000000001000600",
    s: "927568143415293768683417925849375216576142839132986457298634571764851392351729684",
    d: -1383,
  },
  {
    p: "007008000010004060006000801070300502093050008002007000004002000000000390000400070",
    s: "927618453318524967546793821671389542493256718852147639734962185265871394189435276",
    d: -1383,
  },
  {
    p: "008400700000007010106000850040700300000000020009000008390000067001000000600304200",
    s: "928451736435687912176293854842765391713849625569132478394528167281976543657314289",
    d: -1383,
  },
  {
    p: "000270000050000000008039402070904008000050930002800060000000520000000003009180000",
    s: "934278156257641389168539472573964218681752934492813765846397521715426893329185647",
    d: -1383,
  },
  {
    p: "004000060000089000020301709007002000305070028000090040050000106000000500000200080",
    s: "934725861571689234826341759497862315365174928182593647258437196643918572719256483",
    d: -1383,
  },
  {
    p: "930004000002000010000900000000300045810000003070200000006100002000083000007005391",
    s: "935714826742836519168952734629378145814569273573241968356197482291483657487625391",
    d: -1383,
  },
  {
    p: "000000526046002700000000003389000050050004000070600000700540008061000000800000010",
    s: "937418526546932781218765943389127654652894137174653892793541268461289375825376419",
    d: -1383,
  },
  {
    p: "007008000000300980001000030300900857004000003000007400000009060200100000406000502",
    s: "937518246625374981841296735362941857794852613158637429573429168289165374416783592",
    d: -1383,
  },
];
